export default {
  nav: {
    home: '홈',
    features: '기능',
    pricing: '요금',
    faq: 'FAQ',
    translate: '만화 번역',
    startBtn: '번역 시작',
    vip: 'VIP 채널',
    login: '로그인',
    logout: '로그아웃',
    lang: '한국어',
  },
  landing: {
    title: 'KokeManga 스마트 만화 번역 도구',
    subtitle: 'AI 기반 · 일괄 처리 · 원본 렌더링',
    desc: '무료 온라인 만화 번역 도구, JPG, PNG, WEBP 형식 지원',
    hero: {
      badge: 'AI 기반 만화 번역',
      title: '스마트 만화 번역',
      gradientText: '원클릭 완료',
      desc: '일괄 업로드 · AI 인식 · 원본 렌더링 · 다국어 번역',
      startBtn: '번역 시작',
      learnMore: '자세히 보기',
      statsTranslated: '누적 번역',
      statsFree: '무료 할당량',
      statsFreeNum: '20장/일',
      statsAccuracy: '인식 정확도',
    },
    comparison: {
      afterLabel: '번역 후',
      beforeLabel: '원본',
    },
    advantage: {
      tag: '선택하는 이유',
      title: '강력한 번역 능력',
      desc: '만화 번역에 특화된 AI 도구, 번역을 간단하고 효율적으로',
      items: [
        {
          title: 'AI 스마트 번역',
          desc: '각 이미지에 <span class="highlight">대형 모델 번역을 채택, 기계 번역을 배제</span>, 텍스트를 지능적으로 인식하고 원래 레이아웃 유지',
        },
        {
          title: '원본 렌더링',
          desc: '만화 스타일과 배경을 지능적으로 인식, 번역 텍스트의 블러 및 복원을 수행하여 원래 스타일에 완벽하게 융합',
        },
        {
          title: '일괄 처리',
          desc: '여러 만화 이미지를 일괄 업로드, 원클릭으로 챕터 전체 번역, 작업 효율성 대폭 향상',
        },
        {
          title: '다국어 지원',
          desc: '중국어, 번체 중국어, 영어 번역 지원, 향후 더 많은 언어 추가 예정',
        },
        {
          title: '개인정보 보호',
          desc: '전체 데이터 암호화, 번역 완료 후 <span class="highlight">24시간 이내 자동 삭제</span>, 업로드 및 번역 데이터 보관하지 않음',
        },
        {
          title: '다중 형식 내보내기',
          desc: 'JPG, PNG, WEBP 등 다양한 형식의 다운로드 지원, 다양한 플랫폼 요구 사항 충족',
        },
      ],
    },
    pricing: {
      tag: '컴퓨팅 파워',
      title: '유연한 요금제',
      desc: '컴퓨팅 파워를 획득하여 VIP 채널을 잠금 해제, 빠른 번역, 대형 이미지 번역 등 VIP 기능을 즐기세요. 컴퓨팅 파워는 영구적으로 유효합니다',
      unit: '컴퓨팅 파워',
      note: '구매한 컴퓨팅 파워는 영구적으로 유효하며 만료되지 않습니다. VIP 채널은 사용 시 컴퓨팅 파워를 소비하며, 소비량은 이미지 해상도에 따라 계산됩니다.',
      packages: [
        { amount: '300 컴퓨팅 파워', price: '¥6', desc: '약 240-300장의 만화 번역 가능' },
        { amount: '600 컴퓨팅 파워', price: '¥12', desc: '약 480-600장의 만화 번역 가능' },
        { amount: '3000+1000 컴퓨팅 파워', price: '¥60', desc: '약 3200-4000장의 만화 번역 가능', badge: '+33%' },
        { amount: '6000+3000 컴퓨팅 파워', price: '¥120', desc: '약 7200-9000장의 만화 번역 가능', badge: '+50%' },
      ],
    },
    channelCompare: {
      title: '채널 비교',
      free: {
        title: '공개 큐 (무료)',
        desc: '서두르지 않는 사용자를 위한 큐 대기 번역',
        items: ['로그인 불필요', '완전 무료, 컴퓨팅 파워 소비 없음', '큐 우선순위 낮음', '일일 번역 수 제한', '대형 이미지 미지원 (최대 2000×2000)', '온라인 편집 미지원'],
      },
      vip: {
        title: 'VIP 채널 (컴퓨팅 파워 소비)',
        desc: '빠른 번역, 대형 이미지 지원, 사용 시 컴퓨팅 파워 소비',
        items: ['로그인 필요 (무료 기능 모든 권익)', '더 많은 번역 설정', '빠른 큐, 우선 번역', '횟수 무제한, 사용 시 컴퓨팅 파워 소비', '대형 이미지 지원 (최대 2000×20000)', '온라인 편집 지원'],
      },
    },
    faq: {
      tag: '자주 묻는 질문',
      title: 'FAQ',
      desc: '기타 질문이 있으시면 문의해 주세요',
      items: [
        { q: '공개 큐 (무료)에서 몇 장 번역할 수 있나요?', a: '로그인 없이 매일 20장의 무료 번역을 지원합니다. VIP 큐와 동일한 품질입니다.' },
        { q: '왜 번역에 시간이 오래 걸리나요?', a: '품질을 보장하기 위해 대형 모델 번역을 채택하고 있으며, 평균적으로 각 이미지 처리에 7-8초가 소요됩니다.' },
        {
          q: '왜 일부 이미지는 더 많은 컴퓨팅 파워가 필요한가요?',
          a: '일반 이미지는 1 컴퓨팅 파워입니다. 긴 이미지나 초고해상도 이미지만 더 많은 컴퓨팅 파워를 소비합니다. 2 컴퓨팅 파워는 4K 이상의 해상도에 해당합니다.',
        },
        { q: '번역에 문제가 있으면 해결해 주시나요?', a: '번역 관련 모든 문제에 대응합니다. 실패한 경우 실패한 컴퓨팅 파워를 반환하여 사용자의 모든 합법적 권익을 보장합니다.' },
        {
          q: '기존 기계 번역과 대형 모델 번역의 차이는?',
          a: '기존 기계 번역은 고정 규칙과 사전에 의존하며, 번역이 딱딱하고 문맥이 끊기며 의미 오류가 빈번합니다. 대형 모델 번역은 심층 학습을 기반으로 문맥을 이해하여 더 자연스럽고 유창한 번역을 제공하며, 만화의 구어체 표현, 의성어, 문화적 농담 처리에 특히 강합니다.',
        },
      ],
    },
    cta: {
      title: '준비되셨나요?',
      desc: 'Koke Manga를 시작하고 스마트 만화 번역을 경험하세요',
      btn: '지금 번역 시작',
    },
    footer: {
      features: '기능',
      pricing: '요금',
      faq: 'FAQ',
      login: '로그인',
    },
    startBtn: '번역 시작',
  },
  translate: {
    pageTitle: '스마트 만화 번역 도구',
    pageDesc: '원클릭 업로드 · 자동 번역 · 공개 큐 · 원본 렌더링',
    guideArrow: '클릭하여 미리보기',
    uploadTitle: '만화 일괄 업로드',
    previewTitle: '만화 미리보기',
    historyTitle: '번역 기록',
    batchDownload: '일괄 다운로드',
    downloading: '다운로드 중...',
    clearList: '목록 지우기',
    previewDialog: '미리보기',
    confirm: '확인',
    cancel: '취소',
    systemPrompt: '시스템 알림',
    reLogin: '재로그인',
    httpError: 'HTTP 오류',
    deleteConfirm: '이 파일을 삭제하시겠습니까?',
    deleteTitle: '힌트',
    deleteSuccess: '삭제 성공, 백엔드 캐시 클리어 완료',
    deleteFailed: '삭제 실패',
    clearConfirm: '모든 파일 기록과 백엔드 캐시를 클리어하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    clearTitle: '경고',
    clearSuccess: '모든 기록을 클리어하고 백엔드 캐시를 클리어했습니다',
    clearFailed: '클리어 실패',
    selectFilesFirst: '다운로드할 파일을 먼저 선택해 주세요',
    invalidFiles: '선택된 파일 중 {count}개에 유효한 ID가 없어 다운로드할 수 없습니다',
    incompleteFiles: '선택된 파일 중 {count}개가 아직 번역 완료되지 않아 다운로드할 수 없습니다',
    downloadingWait: '다운로드 중, 잠시만 기다려 주세요...',
    batchDownloadStart: '{count}개 파일의 일괄 다운로드 시작...',
    batchDownloadSuccess: '일괄 다운로드 성공',
    batchDownloadFailed: '일괄 다운로드 실패',
    downloadSuccess: '다운로드 성공',
    downloadFailed: '다운로드 실패',
    fileNotFound: '파일이 존재하지 않거나 삭제되었습니다',
    serverError: '서버 내부 오류',
    networkError: '네트워크 오류, 네트워크 연결을 확인하고 다시 시도해 주세요',
    noFileFound: '해당 파일을 찾을 수 없습니다',
    fileIdMissing: '파일 ID가 존재하지 않습니다',
    fileNotComplete: '번역이 아직 완료되지 않았습니다, 잠시만 기다려 주세요',
    paramError: '요청 매개변수 오류, 선택한 파일을 확인해 주세요',
    privacy: '개인정보 처리방침',
    agreement: '이용약관',
    about: '회사 소개',
    batchDownloadFilename: '만화_번역_일괄_다운로드',
    uploadFirst: '먼저 이미지를 업로드해 주세요',
    uploadFailed: '업로드 실패',
    uploadNetworkError: '네트워크 오류',
    uploadResult: '업로드 결과',
    uploadSuccess: '업로드 완료! {count}장 성공',
    joinQueue: '번역 큐 참가',
    imageCount: '{current}/{total}장({size})',
    imagePreview: '만화 미리보기',
  },
  manga: {
    navbar: {
      home: '홈',
      freeQueue: '무료 큐',
      vipQueue: 'VIP 큐',
      loggedIn: '로그인됨',
      currentTasks: '현재 작업',
      currentCredits: '현재 컴퓨팅 파워',
      getCredits: '컴퓨팅 파워 획득',
      myOrders: '주문 내역',
      myTranslations: '번역 기록',
      profile: '프로필',
      feedback: '피드백',
      logout: '로그아웃',
      user: '사용자',
      taskCount: '{count}개',
    },
    footer: {
      privacy: '개인정보 처리방침',
      agreement: '이용약관',
      about: '회사 소개',
    },
    queueCard: {
      publicQueue: '공개 번역 큐:',
      people: '명',
      realtime: '실시간 업데이트 · 전체 공유',
      speedQueue: 'Speed 가속 큐:',
      speedDesc: '매일 첫 100장 · 우선 번역',
      vipQueue: 'VIP 전용 큐:',
      vipDesc: '빠른 번역 · VIP 전용',
    },
    upload: {
      dragHint: '클릭 또는 드래그하여 이미지 업로드',
      translating: '번역 중, 잠시만 기다려 주세요...',
      tip: '최대 {max}장, 각 10MB 이하, 총 50MB 이하',
      processing: '처리 중...',
      onlyImages: '이미지 파일만 업로드 가능합니다!',
      sizeLimit: '이미지 크기는 10MB를 초과할 수 없습니다!',
      totalSizeLimit: '전체 이미지 크기는 50MB를 초과할 수 없습니다',
      maxFiles: '최대 {max}장의 이미지만 선택 가능합니다',
      fileExists: '파일 {name}이(가) 이미 존재합니다, 건너뜁니다',
      added: '{name}을(를) 추가했습니다, 현재 총 {count}장',
      removed: '{name}을(를) 제거했습니다, 남은 {count}장',
      waitTranslate: '번역 중입니다, 번역 완료 후 추가해 주세요',
    },
    fileList: {
      empty: '번역 기록 없음',
      selectAll: '전체 선택 ({selected}/{max})',
      timeJustNow: '방금',
      timeMinutesAgo: '{count}분 전',
      timeHoursAgo: '{count}시간 전',
      timeDaysAgo: '{count}일 전',
    },
    preview: {
      placeholder: '업로드 후 만화를 미리볼 수 있습니다',
      clearAll: '모두 지우기',
      uploading: '업로드 중 {progress}%',
      joinQueue: '번역 큐 참가',
    },
    login: {
      welcomeBack: '다시 오신 것을 환영합니다',
      createAccount: '계정 만들기',
      loginSubtitle: '로그인하여 VIP 전용 번역 채널 이용',
      registerSubtitle: '가입 후 VIP 번역 서비스 체험',
      email: '이메일 주소',
      password: '비밀번호',
      confirmPassword: '비밀번호 확인',
      loginBtn: '로그인',
      registerBtn: '가입',
      noAccount: '계정이 없으신가요? 클릭하여 가입',
      hasAccount: '이미 계정이 있으신가요? 클릭하여 로그인',
      forgotPassword: '비밀번호를 잊으셨나요?',
      loginAgreement: '로그인하면 다음에 동의한 것으로 간주됩니다',
      registerAgreement: '가입하면 다음에 동의한 것으로 간주됩니다',
      and: '및',
      privacyPolicy: '개인정보 처리방침',
      channelCompare: '채널 비교',
      channelDesc: '무료 채널과 VIP 채널의 차이를 확인하세요, VIP 채널은 컴퓨팅 파워를 소비합니다',
      freeQueue: '공개 큐 (무료)',
      freeQueueDesc: '서두르지 않는 사용자를 위한 큐 대기 번역',
      freeItems: ['로그인 불필요', '완전 무료, 컴퓨팅 파워 소비 없음', '큐 우선순위 낮음', '일일 번역 수 제한', '대형 이미지 미지원 (최대 2000×2000)', '온라인 편집 미지원'],
      vipQueue: 'VIP 채널 (컴퓨팅 파워 소비)',
      vipQueueDesc: '빠른 번역, 대형 이미지 지원, 사용 시 컴퓨팅 파워 소비',
      vipItems: ['로그인 필요 (무료 기능 모든 권익)', '더 많은 번역 설정', '빠른 큐, 우선 번역', '횟수 무제한, 사용 시 컴퓨팅 파워 소비', '대형 이미지 지원 (최대 2000×20000)', '온라인 편집 지원'],
      usageTipTitle: '사용 팁',
      usageTipDesc: '무료 사용자는 공개 큐에서 무료 번역을 이용할 수 있습니다. 빠른 번역이나 대형 이미지 번역이 필요한 경우 VIP 채널을 이용하세요. 구매한 컴퓨팅 파워는 만료되지 않습니다.',
      emailRequired: '이메일 주소를 입력해 주세요',
      emailInvalid: '유효한 이메일 주소를 입력해 주세요',
      passwordRequired: '비밀번호를 입력해 주세요',
      passwordMin: '비밀번호는 6자 이상이어야 합니다',
      confirmRequired: '비밀번호를 확인해 주세요',
      confirmMismatch: '입력한 비밀번호가 일치하지 않습니다',
      agreementTitle: '이용약관',
      privacyTitle: '개인정보 처리방침',
      loginSuccess: '로그인 성공',
      registerSuccess: '가입 성공, 로그인해 주세요',
      loginFailed: '로그인 실패, 이메일과 비밀번호를 확인해 주세요',
      registerFailed: '가입 실패, 나중에 다시 시도해 주세요',
    },
    vip: {
      pageTitle: 'VIP 전용 번역 채널',
      pageDesc: 'VIP 전용 · 우선 처리 · 전용 큐 · 무제한',
      uploadTitle: 'VIP 전용 업로드',
      previewTitle: 'VIP 전용 미리보기',
      historyTitle: 'VIP 번역 기록',
      maxImages: '최대 50장',
      eachLimit: '각 10MB 이하',
      totalLimit: '총 50MB 이하',
      batchMax: '일괄 다운로드 최대 50장',
      clearHistory: '클리어 중...',
      clear: '클리어',
      searchPlaceholder: '파일명 입력',
      statusLabel: '번역 상태',
      waiting: '번역 대기',
      translating: '번역 중',
      failed: '번역 실패',
      completed: '완료',
      query: '검색',
      reset: '초기화',
      fileName: '만화명',
      translateStatus: '번역 상태',
      currentQueue: '현재 큐',
      creditsCost: '소비 컴퓨팅 파워',
      targetLanguage: '대상 언어',
      action: '작업',
      noRecords: '번역 기록 없음',
      refresh: '새로고침',
      configTitle: '번역 설정',
      configLangLabel: '대상 번역 언어',
      configLangPlaceholder: '번역 언어 선택',
      configLayoutLabel: '레이아웃 모드',
      configLayoutPlaceholder: '레이아웃 모드 선택',
      configOnlineEditLabel: '온라인 편집(1 크레딧)',
      configOnlineEditOn: '켜기',
      onlineEdit: '온라인 편집',
      editDataMissing: '이 기록에는 편집 데이터가 없습니다',
      configOnlineEditOff: '끄기',
      configConfirm: '확인',
      statusWaiting: '번역 대기',
      statusTranslating: '번역 중',
      statusFailed: '번역 실패',
      statusCompleted: '완료',
      statusExpired: '만료됨',
      statusUnknown: '알 수 없음',
      defaultLang: '간체 중국어',
      fileNotFound: '파일이 존재하지 않거나 삭제되었습니다',
      serverError: '서버 내부 오류, 다운로드 실패',
      networkError: '네트워크 오류, 네트워크 연결을 확인하고 다시 시도해 주세요',
      noFileFound: '해당 파일을 찾을 수 없습니다',
      fileNotComplete: '번역이 아직 완료되지 않았습니다, 잠시만 기다려 주세요',
      fileIdMissing: '파일 ID가 존재하지 않습니다, 미리보기 불가',
      selectFilesFirst: '다운로드할 파일을 먼저 선택해 주세요',
      downloadingWait: '다운로드 중, 잠시만 기다려 주세요...',
      incompleteFiles: '선택된 파일 중 {count}개가 아직 번역 완료되지 않아 다운로드할 수 없습니다',
      batchDownloadStart: 'VIP 일괄 다운로드 시작, {count}개 파일...',
      paramError: '요청 매개변수 오류, 선택한 파일을 확인해 주세요',
      deleteConfirm: '이 기록을 삭제하시겠습니까?',
      deleteTitle: '힌트',
      deleteSuccess: '삭제 성공',
      deleteFailed: '삭제 실패',
      clearConfirm: '완료 및 실패한 모든 번역 기록을 클리어하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
      clearSuccess: '클리어 성공',
      clearFailed: '클리어 실패',
    },
    getPower: {
      title: '만화 번역 컴퓨팅 파워 획득',
      subtitle: '컴퓨팅 파워를 획득하여 VIP 채널을 잠금 해제, 빠른 번역, 대형 이미지 번역 등 VIP 기능을 즐기세요. VIP 기능은 횟수 무제한, 사용 시 컴퓨팅 파워 소비',
      contactAdmin: '관리자 문의',
      currentBalance: '현재 잔액',
      creditsUnit: '컴퓨팅 파워',
      packageTitle: '컴퓨팅 파워 구매 패키지',
      packageDesc: '아래 패키지에서 컴퓨팅 파워를 구매하세요. VIP 채널에 사용 가능, 영구적으로 유효',
      noPackage: '구매 가능한 패키지 없음',
      payMethod: '결제 방법',
      alipay: 'Alipay',
      wechatPay: 'WeChat Pay',
      selectPackage: '패키지를 선택해 주세요',
      buyButton: '지금 구매',
      privacyTitle: '개인정보 보호',
      privacyDesc: '사용자 개인정보를 보호하기 위해 번역된 이미지는 저장하지 않습니다. 모든 번역 데이터는 완료 후 24시간 이내에 자동으로 클리어됩니다. 번역 완료 후 신속하게 다운로드해 주세요.',
      channelCompare: '채널 비교',
      channelDesc: '무료 채널과 VIP 채널의 차이를 확인하세요, VIP 채널은 컴퓨팅 파워를 소비합니다',
      usageTipTitle: '사용 팁',
      usageTipDesc: '무료 사용자는 공개 큐에서 무료 번역을 이용할 수 있습니다. 빠른 번역이나 대형 이미지 번역이 필요한 경우 VIP 채널을 이용하세요. 구매한 컴퓨팅 파워는 만료되지 않습니다.',
      calcTitle: '컴퓨팅 파워 계산식',
      calcDesc: '이미지당 컴퓨팅 파워 = ⌈가로 × 세로 ÷ 4,000,000⌉ (2000×2000 픽셀 = 1 컴퓨팅 파워), 올림하여 합산하며 이미지당 최소 1 컴퓨팅 파워.',
      payPending: '결제 대기',
      paySuccess: '결제 성공!',
      payFailed: '결제 실패',
      createOrderFailed: '결제 주문 생성 실패',
      pleaseSelectPackage: '먼저 패키지를 선택해 주세요',
      qrcodeTitle: 'QR 코드 결제',
      qrcodeDesc: '{method}(으)로 스캔하여 결제',
      payConfirming: '결제 확인 중...',
      payTimeout: '결제 시간 초과, 다시 시도해 주세요',
    },
    order: {
      loading: '로딩 중...',
      typeGift: '선물',
      typeAlipay: 'Alipay',
      typeWechat: 'WeChat',
      typeBilibili: 'Bilibili',
      typePaypal: 'PayPal',
      statePending: '결제 대기',
      stateSuccess: '결제 성공',
      stateFailed: '결제 실패',
      stateConfirming: '확인 중',
      stateClosed: '닫기',
      unknown: '알 수 없음',
    },
    userMessage: {
      pending: '처리 대기',
      replied: '답변 완료',
      placeholder: '메시지를 입력해 주세요...',
      submitting: '제출 중...',
      submit: '제출',
      messageContent: '메시지 내용',
      suggestionContent: '제안 내용',
      message: '메시지',
      suggestion: '제안',
    },
    userProfile: {
      nicknamePlaceholder: '닉네임 입력',
      phoneBound: '바인딩됨 {phone}',
      phoneUnbound: '전화 미바인딩',
      emailBound: '바인딩됨 {email}',
      emailUnbound: '이메일 미바인딩',
      wechatBound: 'WeChat 인증됨',
      wechatUnbound: 'WeChat 미바인딩',
      change: '변경',
      bind: '바인딩',
      unbind: '언바인딩',
      selectImageError: '이미지 파일을 선택해 주세요',
      imageSizeError: '이미지 크기는 5MB를 초과할 수 없습니다',
      avatarSuccess: '아바타 업로드 성공',
      avatarFailed: '업로드 실패',
      avatarRetry: '업로드 실패, 다시 시도해 주세요',
      saveSuccess: '프로필 저장 성공',
      saveFailed: '저장 실패',
      saveRetry: '저장 실패, 다시 시도해 주세요',
    },
    resetPassword: {
      title: '비밀번호 재설정',
      step1: '이메일 인증',
      step2: '코드 입력',
      step3: '새 비밀번호 설정',
      emailPlaceholder: '등록 이메일 입력',
      sendCode: '코드 전송',
      codePlaceholder: '인증 코드 입력',
      newPassword: '새 비밀번호',
      confirmPassword: '비밀번호 확인',
      resetBtn: '비밀번호 재설정',
      backToLogin: '로그인으로 돌아가기',
      stepDesc1: '등록 시 사용한 이메일 주소를 입력해 주세요',
      stepDesc2: '수신한 6자리 인증 코드를 입력해 주세요',
      stepDesc3: '새 비밀번호를 설정해 주세요',
      codeSentTo: '인증 코드 전송 완료:',
      resendAfter: '{countdown}초 후 재전송 가능',
      resendCode: '인증 코드 재전송',
      verifyBtn: '인증',
      codeRequired: '인증 코드를 입력해 주세요',
      codeLen: '인증 코드는 6자리 숫자입니다',
      emailRequired: '이메일 주소를 입력해 주세요',
      emailInvalid: '유효한 이메일 주소를 입력해 주세요',
      passwordRequired: '비밀번호를 입력해 주세요',
      passwordMin: '비밀번호는 6자 이상이어야 합니다',
      confirmRequired: '비밀번호를 확인해 주세요',
      confirmMismatch: '입력한 비밀번호가 일치하지 않습니다',
      codeSentSuccess: '인증 코드를 전송했습니다, 이메일을 확인해 주세요',
      verifySuccess: '인증 성공, 새 비밀번호를 설정해 주세요',
      resetSuccess: '비밀번호 변경 성공, 다시 로그인해 주세요',
    },
    seo: {
      landing: {
        title: 'KokeManga 스마트 만화 번역 도구 - AI 기반 · 일괄 처리 · 원본 렌더링',
        description: 'KokeManga는 무료 온라인 만화 번역 도구, JPG, PNG, WEBP 형식 지원, AI 스마트 번역 및 일괄 처리.',
      },
      translate: {
        title: 'KokeManga 만화 번역 - 온라인 번역 도구',
        description: '온라인 만화 번역 도구, 일괄 업로드, 자동 번역, 원본 렌더링 지원',
      },
      vip: {
        title: 'KokeManga VIP 전용 번역 채널',
        description: 'VIP 전용 만화 번역 채널, 우선 처리, 전용 큐, 횟수 무제한',
      },
      faq: {
        title: "KokeManga 자주 묻는 질문 - 무료 온라인 만화 번역 도구",
        description: "KokeManga 만화 번역 FAQ: 무료 한도, 번역 속도, 크레딧, 대형 이미지, 개인정보 보호, AI와 기계 번역 차이.",
      },
      guide: {
        title: "만화 번역 완벽 가이드 - 온라인 AI 만화 현지화 튜토리얼 · KokeManga",
        description: "업로드부터 내보내기까지 만화 번역 가이드. 일괄 처리, 원본 렌더링, 화질 설정, 다국어 번역 팁.",
      },
      privacy: {
        title: "KokeManga 개인정보 처리방침 - 만화 번역 데이터 보호",
        description: "KokeManga가 업로드된 만화 이미지를 처리하는 방법. 로컬 우선 처리, 24시간 자동 삭제, 학습에 사용하지 않음.",
      },
      agreement: {
        title: "KokeManga 이용약관 - 온라인 만화 번역 서비스",
        description: "온라인 만화 번역 도구 KokeManga 이용약관. 이용 규칙, 면책 조항, 책임 제한.",
      },
      login: {
        title: "KokeManga 로그인",
        description: "KokeManga에 로그인하여 VIP 번역 채널과 번역 기록을 이용하세요.",
      },
      resetPassword: {
        title: "비밀번호 재설정 - KokeManga",
        description: "KokeManga 계정 비밀번호를 재설정합니다.",
      },
    },
    privacy: {
      intro: '온라인 만화 번역 도구에 오신 것을 환영합니다. 개인정보와 데이터 보안을 매우 중요하게 생각합니다. 이 개인정보 처리방침에서는 귀하의 정보, 특히 업로드된 만화 이미지의 수집, 사용, 저장 및 처리 방법을 명확하게 설명합니다.',
      s1Title: '1. 정보의 수집',
      s1Content: '본 도구 사용 시 귀하가 적극적으로 선택하고 업로드한 만화 이미지 파일만 수집 및 접근합니다. 이 외에 개인을 식별할 수 있는 정보(이름, 이메일, IP 주소, 기기 정보 등)를 적극적으로 수집, 저장 또는 요청하지 않습니다.',
      s2Title: '2. 정보의 사용 방법',
      s2Content: '업로드된 만화 이미지는 귀하가 요청한 즉시 번역 서비스 제공에만 사용됩니다. 핵심 이미지 처리, 텍스트 인식 및 번역 계산은 귀하의 로컬 브라우저 또는 기기에서 수행됩니다. 다음을 약속합니다:',
      s2Item1: '로컬 처리: 업로드된 이미지 파일은 당사 서버 또는 제3자 서버로 자동적, 적극적 또는 정기적으로 전송되어 처리되지 않습니다.',
      s2Item2: '목적 제한: 이미지 콘텐츠는 번역 결과 생성에만 사용되며, 기계 학습 모델 훈련, 콘텐츠 분석, 마케팅 또는 재배포 등의 다른 목적으로 사용되지 않습니다.',
      s3Title: '3. 정보의 저장 및 보유',
      s3Content: '임시 파일 보안의 중요성을 잘 알고 있습니다. 데이터 저장 원칙은 다음과 같습니다:',
      s3Item1: '자동 삭제: 업로드된 모든 원본 이미지 파일과 생성된 번역 결과는 처리 완료 후 24시간 이내에 시스템에서 영구적이고 되돌릴 수 없게 삭제됩니다.',
      s3Item2: '장기 아카이브 없음: 업로드된 콘텐츠와 관련된 장기 데이터베이스, 아카이브 또는 백업을 만들거나 보유하지 않습니다.',
      s4Title: '4. 귀하의 권리',
      s4Content: '데이터 제공자로서 귀하는 다음과 같은 권리가 있습니다:',
      s4Item1: '통제권: 업로드된 콘텐츠를 완전히 통제할 수 있습니다. 사용 후 언제든지 브라우저 탭을 닫을 수 있습니다.',
      s4Item2: '알 권리: 이 정책을 통해 파일 처리 방법을 이해할 권리가 있습니다.',
      s5Title: '5. 제3자 서비스',
      s5Content: '현재 서비스에는 제3자 분석, 광고 또는 추적 도구의 포함이 포함되지 않습니다. 기능 개선을 위해 신뢰할 수 있는 제3자 서비스가 도입되는 경우, 이 정책에 명확히 설명하고 동일하게 엄격한 개인정보 보호 기준을 충족하도록 보장합니다.',
      s6Title: '6. 개인정보 처리방침 변경',
      s6Content: '이 개인정보 처리방침은 수시로 업데이트될 수 있습니다. 중요한 변경 사항이 있는 경우 도구 인터페이스에 눈에 띄는 공지를 게시합니다. 서비스의 계속적인 사용은 업데이트된 정책의 수락을 구성합니다.',
      s7Title: '7. 문의하기',
      s7Content: "이 개인정보 처리방침 또는 데이터 처리 관행에 대해 질문, 의견 또는 우려 사항이 있으시면 다음으로 연락해 주세요: Koke7359{'@'}163.com",
      s8Title: '8. 적용 법률',
      s8Content: '이 개인정보 처리방침의 체결, 실행 및 해석은 중화인민공화국 법률에 따릅니다',
    },
    agreement: {
      updateDate: '최종 업데이트: 2026년 4월 2일',
      intro: '온라인 만화 번역 도구(이하 "본 도구" 또는 "본 서비스")에 오신 것을 환영합니다. 사용 전 이 이용약관(이하 "본 약관")의 전체 내용을 주의 깊게 읽어 주시기 바랍니다. 본 약관의 어떤 조항에도 동의하지 않으시면 즉시 본 도구의 사용을 중단해 주세요. 업로드, 접근 또는 사용함으로써 본 약관 및 개인정보 처리방침을 읽고 이해하며 완전히 수락한 것으로 간주됩니다.',
      s1Title: '1. 서비스 설명',
      s1Content: '본 도구는 무료 온라인 기술 번역 서비스를 제공합니다: 텍스트가 포함된 만화 이미지를 업로드하면 기술적 수단(이미지 인식, 기계 번역 등)을 통해 번역 결과를 생성합니다. 번역 결과는 알고리즘에 의해 자동으로 생성되며 이해 보조만을 목적으로 하며, 정확성, 완전성, 적합성에 대해 명시적 또는 묵시적 보증을 하지 않음을 이해하고 동의합니다.',
      s2Title: '2. 사용자 행동 규범',
      s2Content: '귀하는 모든 적용 법률 및 규정을 준수하고 본 서비스 사용으로 인한 모든 책임을 독립적으로 부담할 것을 약속합니다. 본 서비스 사용 시 다음 행위를 해서는 안 됩니다:',
      s2Subtitle1: '다음 내용을 포함하거나 관련된 만화 이미지의 업로드, 전송, 공유 또는 저장:',
      s2Item1: '권리 침해 콘텐츠: 타인의 지적 재산권(저작권, 상표권 등), 초상권, 개인정보 보호권 또는 기타 정당한 권리와 이익을 침해하는 콘텐츠.',
      s2Item2: '불법 및 비준수 콘텐츠: 법률, 규정, 규칙, 조례를 위반하는 콘텐츠 또는 불법, 사기, 명예 훼손, 괴롭힘, 협박 정보를 포함하는 콘텐츠.',
      s2Item3: '유해 및 부적절 콘텐츠: 포르노, 외설, 폭력, 유혈, 혐오 발언을 포함하는 콘텐츠 또는 인종, 성별, 종교, 장애, 성적 지향에 따른 차별을 조장하는 콘텐츠.',
      s2Item4: '민감한 콘텐츠: 국가 기밀, 국가 안보, 공공 안전, 정치적 민감성 또는 미성년자에게 부적절한 콘텐츠를 포함하는 콘텐츠.',
      s2Subtitle2: '기타 금지 행위:',
      s2Item5: '본 도구를 상업적 목적, 불법 목적 또는 서비스의 정상적인 운영을 방해하거나 파괴하는 행위(시스템 침입 시도, 악성 소프트웨어 업로드 등)에 사용하는 것.',
      s2Item6: '개인 또는 단체를 사칭하거나 개인 또는 단체와의 관계에 대해 허위 진술을 하는 것.',
      s3Title: '3. 사용자 업로드 콘텐츠의 책임',
      s3Content1: '귀하는 업로드한 모든 만화 이미지 콘텐츠(이하 "사용자 콘텐츠")에 대한 전적인 법적 책임을 부담합니다. 업로드에 필요한 모든 법적 권리를 보유하거나 충분한 권한을 획득했음을 보증하며, 콘텐츠의 사용이 법률을 위반하지 않고 제3자의 권리를 침해하지 않음을 보증합니다.',
      s3Content2: '업로드된 콘텐츠가 본 약관을 위반한 경우 관련 법적 책임은 귀하가 부담합니다. 이로 인해 당사 또는 제3자에게 손해가 발생한 경우 귀하는 전액 배상할 책임이 있습니다.',
      s4Title: '4. 지적 재산권',
      s4Content1: '귀하의 권리: 업로드한 원본 만화 이미지에 대한 모든 지적 재산권 및 관련 권리를 보유합니다. 업로드 행위 자체가 권리의 이전을 의미하지는 않습니다.',
      s4Content2: '당사의 권리: 본 도구 및 서비스(소프트웨어, 인터페이스, 로고, 기술 등을 포함하되 이에 국한되지 않음)에 포함된 모든 지적 재산권 및 관련 권리는 당사 및/또는 라이선스 제공자에게 귀속됩니다. 당사의 명시적인 서면 허가 없이 어떤 형태로든 복제, 수정, 리버스 엔지니어링 또는 상업적 사용을 할 수 없습니다.',
      s5Title: '5. 서비스의 변경, 중단 및 종료',
      s5Content1: '당사는 귀하에게 사전 통지 없이 언제든지 본 서비스(또는 그 일부)를 수정, 일시 중단 또는 중단할 권리를 보유하며, 귀하 또는 제3자에 대한 책임을 지지 않습니다.',
      s5Content2: '귀하가 본 약관의 어떤 조항을 위반했을 합리적인 근거가 있는 경우, 당사는 일방적으로 즉시 서비스 제공을 일시 중단 또는 종료하고 관련 사용자 콘텐츠를 삭제할 권리를 가지며 책임을 지지 않습니다.',
      s6Title: '6. 면책 조항',
      s6Content: '적용 법률이 허용하는 최대 범위에서 본 서비스는 "있는 그대로" 및 "이용 가능한 상태"로 제공되며 어떤 형태의 명시적 또는 묵시적 보증도 제공하지 않습니다. 귀하는 다음을 이해하고 동의합니다:',
      s6Item1: '서비스가 중단되지 않고, 적시에, 안전하고, 오류가 없음을 보증하지 않습니다.',
      s6Item2: '번역 결과의 정확성, 신뢰성 또는 적합성을 보증하지 않습니다. 번역 결과는 참고용이며 전문적인 번역 조언을 구성하지 않습니다. 그 가치를 판단하고 사용 결과에 책임을 집니다.',
      s6Item3: '업로드된 콘텐츠로 인해 발생하는 직접적, 간접적, 부수적, 징벌적 또는 결과적 손해(데이터 손실, 이익 손실, 영업권 손실 등을 포함하되 이에 국한되지 않음)에 대해, 손해 가능성을 통보받았는지 여부에 관계없이 책임을 지지 않습니다.',
      s7Title: '7. 데이터 보유',
      s7Content: '개인정보 처리방침에 따라 업로드된 이미지와 생성된 번역 결과를 일시적으로 처리함을 확인하고 동의합니다. 모든 데이터는 처리 완료 후 24시간 이내에 자동으로 클리어됩니다. 보유하려는 콘텐츠는 귀하가 직접 백업할 책임이 있습니다.',
      s8Title: '8. 약관의 수정',
      s8Content: '당사는 언제든지 본 약관을 업데이트하거나 수정할 권리를 보유합니다. 업데이트된 약관은 이 페이지에 게시되고 "최종 업데이트" 날짜가 업데이트됩니다. 서비스의 계속적인 사용은 업데이트된 약관의 수락을 구성합니다. 최신 조항을 확인하기 위해 이 페이지를 정기적으로 확인하시기를 권장합니다.',
      s9Title: '9. 기타 조항',
      s9Item1: '분리 가능성: 본 약관의 어떤 조항이 무효이거나 집행할 수 없는 것으로 판명된 경우, 해당 조항은 필요한 최소한의 범위로 제외되며 다른 조항의 유효성에는 영향을 미치지 않습니다.',
      s9Item2: '완전 합의: 본 약관 및 개인정보 처리방침은 본 서비스에 관한 귀하와 당사 간의 완전한 합의를 구성하며 이전의 구두 또는 서면 합의에 우선합니다.',
    },
    about: {
      title: 'Koke에 오신 것을 환영합니다',
      intro: '간단한 믿음에서 시작되었습니다: 언어는 훌륭한 만화 세계를 탐험하는 장벽이 되어서는 안 됩니다.',
      missionTitle: '우리의 사명',
      missionContent: 'Koke는 모든 만화 애호가가 장벽 없이 독서를 즐길 수 있는 진정으로 효율적이고 간단하며 무료의 지능형 번역 도구를 만드는 데 전념하고 있습니다. 기술은 사람에게 봉사해야 하며, 가장 원활한 방식으로 장벽을 제거하고 훌륭한 이야기와 예술을 마음에 전달해야 한다고 믿습니다.',
      coreTitle: '우리의 핵심: 개인정보 보호와 편의성',
      toolTitle: '순수한 도구',
      toolContent: 'Koke는 기능에 특화된 도구입니다. 업로드하면 번역합니다, 그게 다입니다. 커뮤니티를 만들지 않고, 콘텐츠를 저장하지 않고, 사용자를 추적하지 않습니다.',
      privacyTitle: '개인정보 보호 우선',
      privacyContent: '귀하의 데이터는 귀하만을 위해 작동합니다. 개인정보 보호를 최대화하기 위해 번역에 필요한 이미지 처리 및 인식은 브라우저 로컬에서 완료됩니다. 원본 이미지를 서버로 전송하지 않습니다. 모든 관련 데이터는 24시간 후 자동으로 완전히 클리어됩니다. 사본을 보유하지 않습니다. 이것이 귀하의 신뢰에 대한 우리의 약속입니다.',
      efficientTitle: '간단하고 효율적',
      efficientContent: '불필요한 기능과 복잡한 인터페이스를 배제하고, 업로드부터 번역 결과까지 전체 속도와 경험 향상에 집중하여 번역을 페이지를 넘기는 것처럼 자연스럽고 유창하게 만듭니다.',
      futureTitle: '미래를 향한展望',
      futureContent: '번역의 정확성과 복잡한 레이아웃 처리 능력을 지속적으로 최적화하고, "효율적, 간단, 무료, 안전"의 초심을 엄격히 준수합니다. Koke가 만화 우주를 탐험할 때 여러분의 손에 가볍고 신뢰할 수 있는 열쇠가 되기를 바랍니다.',
      thankYou: '이용해 주셔서 감사합니다.',
      signature: 'Koke 팀',
    },
  },
  seoPage:   {
    "faq": {
      "h1": "자주 묻는 질문",
      "lead": "무료 한도, 번역 속도, 크레딧, 개인정보 보호, 사용 방법에 대한 상세 답변입니다.",
      "ctaTitle": "질문이 더 있으신가요? 도구를 사용해 보세요",
      "ctaDesc": "만화 이미지를 업로드하고 AI 번역과 원본 렌더링을 무료로 체험하세요.",
      "items": [
        {
          "q": "무료 공용 큐는 하루에 몇 페이지를 번역하나요?",
          "a": "로그인 없이 하루 20회 무료 번역을 지원하며 품질은 VIP 큐와 동일합니다."
        },
        {
          "q": "번역에 왜 시간이 걸리나요?",
          "a": "품질을 위해 대형 모델 번역을 사용합니다. 이미지당 평균 7~8초 정도입니다."
        },
        {
          "q": "이미지에 따라 크레딧이 더 드는 이유는?",
          "a": "일반 이미지는 1 크레딧입니다. 초고해상도/초장 이미지는 추가 소모될 수 있습니다."
        },
        {
          "q": "번역에 문제가 있으면 어떻게 하나요?",
          "a": "번역 문제는 전액 지원합니다. 실패한 번역은 크레딧을 환불합니다."
        },
        {
          "q": "기계 번역과 대형 모델 번역의 차이는?",
          "a": "기존 기계 번역은 규칙 기반이라 어색할 수 있습니다. 대형 모델은 문맥, 대사, 의성어, 문화적 표현을 더 자연스럽게 처리합니다."
        },
        {
          "q": "업로드한 이미지는 저장되나요?",
          "a": "장기 저장하지 않습니다. 번역 결과 생성에만 사용하며 24시간 내 자동 삭제, 학습에도 사용하지 않습니다."
        },
        {
          "q": "지원 형식은 무엇인가요?",
          "a": "JPG, PNG, WEBP 등 일반 형식을 지원합니다."
        },
        {
          "q": "지원 언어는 무엇인가요?",
          "a": "현재 중국어, 간체/번체, 영어 등을 지원하며 더 많은 언어를 추가 예정입니다."
        }
      ]
    },
    "guide": {
      "h1": "만화 번역 완벽 가이드",
      "lead": "일본 만화 중문화, 영문화, 챕터 배치 처리까지 준비부터 내보내기까지 다룹니다.",
      "ctaTitle": "준비되셨나요?",
      "ctaDesc": "온라인 도구를 열고 이미지를 일괄 업로드하여 AI 만화 번역을 체험하세요.",
      "sections": [
        {
          "title": "1. 번역 전 준비",
          "paragraphs": [
            "고품질 입력이 고품질 결과를 만듭니다. 선명한 스크린샷이나 스캔을 권장합니다.",
            "장문/고해상도 이미지는 대형 이미지 지원 여부를 확인하세요."
          ],
          "list": [
            "JPG / PNG / WEBP 사용",
            "문자 영역 선명하게",
            "읽기 순서로 정리"
          ]
        },
        {
          "title": "2. 일괄 업로드",
          "paragraphs": [
            "번역 페이지에서 여러 이미지를 한 번에 선택할 수 있습니다. 파일별 진행률을 확인하세요.",
            "페이지 단위보다 챕터 단위 일괄 처리가 효율적입니다."
          ],
          "list": [
            "여러 이미지 한 번에",
            "실시간 진행률",
            "완료 후 일괄 다운로드"
          ]
        },
        {
          "title": "3. 원본 렌더링이 중요한 이유",
          "paragraphs": [
            "텍스트를 덮어쓰면 부자연스러울 수 있습니다. 원본 렌더링은 배경과 어우러져 더 전문적인 현지화 결과를 줍니다."
          ],
          "list": [
            "작화 스타일 유지",
            "말풍선/배경과 자연스러운 결합",
            "공유·게시에 적합한 품질"
          ]
        },
        {
          "title": "4. 품질과 속도 균형",
          "paragraphs": [
            "급할 때는 VIP를, 무료 이용 시에는 공용 큐로도 동일 품질을 얻을 수 있습니다."
          ],
          "list": [
            "공용 큐: 무료·대기",
            "VIP: 빠름·대형 이미지·상세 설정",
            "실패 시 크레딧 환불 가능"
          ]
        },
        {
          "title": "5. 내보내기와 후속 처리",
          "paragraphs": [
            "완료 후에는 바로 다운로드하세요. 용도에 맞는 형식을 선택할 수 있습니다.",
            "고유명사 교정에는 원문/번역 대응을 보관하는 것이 좋습니다."
          ],
          "list": [
            "JPG / PNG / WEBP 지원",
            "원문/번문 보관",
            "저작권 및 게시 규칙 준수"
          ]
        }
      ]
    }
  },
}
